import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Sejour from "./pages/Sejour";
import { Loader } from "./ui/components";

// Pages admin chargées à la demande : les visiteurs ne téléchargent pas leur code
// (ni Firebase Auth). La persistance de session est définie dans Login.
const Login = lazy(() => import("./pages/Login"));
const Admin = lazy(() => import("./pages/Admin"));
const SejourAdmin = lazy(() => import("./pages/SejourAdmin"));
const PrivateRoute = lazy(() => import("./PrivateRoute"));

function App() {
  return (
    <Router>
      <Suspense fallback={<Loader label="Chargement..." />}>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/admin" element={
            <PrivateRoute>
              <Admin />
            </PrivateRoute>
          } />

          <Route path="/sejour-admin" element={
            <PrivateRoute>
              <SejourAdmin />
            </PrivateRoute>
          } />

          <Route path="/sejour/:token" element={<Sejour />} />
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="*" element={<div className="message-page"><h2 className="page-title">Page non trouvée</h2></div>} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
